import { Css, MultiSelectField } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { observer } from "mobx-react";
import { ConfigureBidGroupsStepQuery } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";
import { PlanBasedBidPackageBidPlanGroup } from "src/routes/bids/plan-based-bid-package/utils";

type BidPlanDimensionRowsProps = {
  group: ObjectState<PlanBasedBidPackageBidPlanGroup>;
  dimensionResults: ConfigureBidGroupsStepQuery["potentialBidPlanDimensions"];
};

export const BidPlanDimensionRows = observer(function BidPlanDimensionRows(props: BidPlanDimensionRowsProps) {
  const { group, dimensionResults } = props;
  return (
    <div css={Css.df.fdc.gap2.$}>
      {dimensionResults.map((result) => {
        const dim = group.dimensions.rows.find((d) => d.globalOptionTypeId.value === result.type.id);
        if (!dim) return null;
        return (
          <MultiSelectField
            fullWidth
            key={result.id}
            label={result.type.name}
            values={dim.globalOptionIds.value ?? []}
            options={result.options}
            onSelect={(ids) => dim.globalOptionIds.set(ids)}
            getOptionValue={(go) => go.id}
            getOptionLabel={(go) => go.name}
          />
        );
      })}
    </div>
  );
});
